import React, {Component, PropTypes} from 'react';
import { RequiredLabel, InlineWarning, errorUtilities } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './guid-element.style.js';

export class GuidElement extends Component {
  handleInput(e) {
    const { onChange } = this.props;
    const value = e.target.value;
    var hexOnly = value.replace(/[^0-9a-fA-F/-]/g, '');
    var trimmedStr = hexOnly.substr(0, 36);
    onChange(trimmedStr);
  }

  getValue() {
    const { response, defaultValue } = this.props;
    return response ? response : defaultValue ? defaultValue : "";
  }

  render() {
    const { isRequired, label, id, response, disabled, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');
    const inlineErrors = errors && errors.filter(err => err.type === errorUtilities.errorTypes.inline);

    return (
      <div className={css.group + ' validated-section'}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          isRequired={isRequired}
          css={{requiredLabel: css.label}}/>
        <div className={css.displayWrapper}>
          <input
            id={id}
            type="text"
            value={this.getValue()}
            onChange={e => this.handleInput(e)}
            className={css.input + ' validated-input'}
            placeholder={"xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"}
            disabled={disabled}
            aria-required={isRequired}
            aria-invalid={hasErrors && showErrors}
            aria-describedby={errorIds} />
          {inlineErrors && inlineErrors.map(warn => (
            <InlineWarning key={warn.id} warn={!!response ? warn.errorMessage : null}/>
          ))}
        </div>
      </div>
    );
  }
}

GuidElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (GuidElement);



// WEBPACK FOOTER //
// src/common/form-elements/guid-element-folder/guid-element.js